if (!customElements.get("sprong-customer-link")) {
  class SprongCustomerLink extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector("input");
      this.status = this.querySelector('[role="status"]');
      this.button = this.querySelector("[data-save]");
      if (!this.input) return;
      this.saved = this.input.value;
      this.input.addEventListener("change", (event) => event.stopPropagation());
      this.button.addEventListener("click", () => this.save());
    }
    async save() {
      if (this.pending) {
        await this.pending;
        if (this.input.value !== this.saved) return this.save();
        return;
      }
      const value = this.input.value.trim();
      const digits = value.replace(/\D/g, "");
      if (
        value &&
        (/[a-z]/i.test(value) ||
          !(
            digits.length === 10 ||
            (digits.length === 11 && digits.startsWith("1")) ||
            (value.startsWith("+") && digits.length >= 8 && digits.length <= 15)
          ))
      ) {
        this.status.textContent = this.dataset.invalid;
        return false;
      }
      if (!value && !this.dataset.formId) {
        this.status.textContent = this.dataset.invalid;
        return false;
      }
      this.button.disabled = true;
      this.status.textContent = this.dataset.saving;
      this.pending = (async () => {
        try {
          if (this.dataset.formId) {
            const cart = await fetch(this.dataset.cartUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: { sprong_in_store_phone: value },
              }),
              signal: AbortSignal.timeout(8000),
            });
            if (!cart.ok) throw new Error("cart_unavailable");
          }
          if (this.dataset.signedIn && value) {
            const token = await fetch(this.dataset.proxyUrl, {
              cache: "no-store",
              signal: AbortSignal.timeout(8000),
            });
            if (!token.ok) throw new Error("link_unavailable");
            const { nonce } = await token.json();
            const link = await fetch(this.dataset.proxyUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ phone: value, nonce }),
              signal: AbortSignal.timeout(8000),
            });
            if (!link.ok) throw new Error("link_unavailable");
          }
          this.saved = value;
          for (const other of document.querySelectorAll(
            "sprong-customer-link",
          )) {
            if (
              other !== this &&
              other.input &&
              other.input.value === other.saved
            ) {
              other.input.value = value;
              other.saved = value;
            }
          }
          this.status.textContent = this.dataset.saved;
          return true;
        } catch {
          this.status.textContent = this.dataset.error;
          return false;
        } finally {
          this.button.disabled = false;
          this.pending = null;
        }
      })();
      return this.pending;
    }
  }
  customElements.define("sprong-customer-link", SprongCustomerLink);
  const resubmitting = new WeakSet();
  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (event.submitter?.name !== "checkout" || resubmitting.has(form))
        return;
      const component = [
        ...document.querySelectorAll("sprong-customer-link"),
      ].find(
        (element) =>
          element.dataset.formId === form.id &&
          element.input &&
          (element.pending || element.input.value !== element.saved),
      );
      if (!component) return;
      event.preventDefault();
      const submitter = event.submitter;
      await component.save();
      if (!form.isConnected) return;
      resubmitting.add(form);
      try {
        form.requestSubmit(submitter);
      } finally {
        resubmitting.delete(form);
      }
    },
    true,
  );
}
